// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/iconos/icon-filtro.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  flex-direction: row;
  font-weight: bold;
  flex: 1 1;
}
.header :nth-child(1) {
  width: 40%;
}

.header :nth-child(2) {
  width: 20%;
}
.header :nth-child(3) {
  width: 20%;
}
.header :nth-child(4) {
  width: 20%;
}

.encuesta {
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
}
.encuesta > :nth-child(1) {
  width: 40%;
  display: flex;
  flex-direction: column;
  background-color: red;
  color: white;
  padding-left: 20px;
}
.encuesta > :first-child.activa {
  background-color: green;
}

.encuesta > :nth-child(1) > :nth-child(1) {
  font-weight: bold;
  font-size: 30px;
}

.encuesta > :nth-child(2) {
  padding-left: 10px;
  width: 20%;
  display: flex;
  background-color: #efcbce;
  vertical-align: middle;
  align-items: center;
}
.encuesta > :nth-child(3) {
  width: 20%;
  background-color: #efcbce;
}
.encuesta > :nth-child(4) {
  width: 20%;
  background-color: #efcbce;
}
/* 
.checkbox-container {
  position: relative;
  width: 40px;
  height: 20px;
  cursor: pointer;
}

input[type="checkbox"] {
  display: none;
} */
/* 
label {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 20px;
  background-color: rebeccapurple;
  border-radius: 10px;
  transition: background-color 0.3s ease;
} */

.txtBuscar {
  display: flex;
  flex-direction: row;

  width: 200px;
  height: 40px;

  margin-right: 20px;
  padding-left: 40px;
  padding-right: 10px;
  font-size: 1rem;
  background-color: white;
  border-width: 1px;
  border-radius: 10px;
  border-style: solid;
  border-color: var(--gris-texto);
  color: var(--gris-claro-hint);
}

.icono-input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 20px 20px;
  background-position: 10px center;
  background-repeat: no-repeat;
  padding-left: 36px; /* Asegura que el texto no se solape con el icono */
}

.p-estado-encuesta {
  width: auto;
  font-weight: bold;
  font-size: 20px;

  text-align: left;
  margin-left: 20px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/panel/Panel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAO;AACT;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;;;;;;;;;;GAUG;AACH;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;;EAEZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,yDAA4D;EAC5D,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".header {\n  display: flex;\n  flex-direction: row;\n  font-weight: bold;\n  flex: 1;\n}\n.header :nth-child(1) {\n  width: 40%;\n}\n\n.header :nth-child(2) {\n  width: 20%;\n}\n.header :nth-child(3) {\n  width: 20%;\n}\n.header :nth-child(4) {\n  width: 20%;\n}\n\n.encuesta {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 4px;\n}\n.encuesta > :nth-child(1) {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  background-color: red;\n  color: white;\n  padding-left: 20px;\n}\n.encuesta > :first-child.activa {\n  background-color: green;\n}\n\n.encuesta > :nth-child(1) > :nth-child(1) {\n  font-weight: bold;\n  font-size: 30px;\n}\n\n.encuesta > :nth-child(2) {\n  padding-left: 10px;\n  width: 20%;\n  display: flex;\n  background-color: #efcbce;\n  vertical-align: middle;\n  align-items: center;\n}\n.encuesta > :nth-child(3) {\n  width: 20%;\n  background-color: #efcbce;\n}\n.encuesta > :nth-child(4) {\n  width: 20%;\n  background-color: #efcbce;\n}\n/* \n.checkbox-container {\n  position: relative;\n  width: 40px;\n  height: 20px;\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n} */\n/* \nlabel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 40px;\n  height: 20px;\n  background-color: rebeccapurple;\n  border-radius: 10px;\n  transition: background-color 0.3s ease;\n} */\n\n.txtBuscar {\n  display: flex;\n  flex-direction: row;\n\n  width: 200px;\n  height: 40px;\n\n  margin-right: 20px;\n  padding-left: 40px;\n  padding-right: 10px;\n  font-size: 1rem;\n  background-color: white;\n  border-width: 1px;\n  border-radius: 10px;\n  border-style: solid;\n  border-color: var(--gris-texto);\n  color: var(--gris-claro-hint);\n}\n\n.icono-input {\n  background-image: url(\"../../assets/iconos/icon-filtro.svg\");\n  background-size: 20px 20px;\n  background-position: 10px center;\n  background-repeat: no-repeat;\n  padding-left: 36px; /* Asegura que el texto no se solape con el icono */\n}\n\n.p-estado-encuesta {\n  width: auto;\n  font-weight: bold;\n  font-size: 20px;\n\n  text-align: left;\n  margin-left: 20px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
